export default {"src":"/_next/static/media/logo-cta-sign.272b942e.svg","height":71,"width":60,"blurWidth":0,"blurHeight":0};